// Adaptador de carga de Google Maps JavaScript (ADR-020, G6). El renderer
// del mapa (GoogleMap.tsx) solo conoce esta interfaz: en produccion la
// implementa `@googlemaps/js-api-loader`; en los tests, un SDK falso. Asi
// ningun test baja codigo de Google ni depende de una clave.
//
// El SDK expone solo lo que la torre usa. Achicar la superficie hace que el
// falso de los tests sea chico y que un cambio de Google se note aca.
import { importLibrary, setOptions } from "@googlemaps/js-api-loader";
// Version trimestral: cambia cuatro veces por ano y con aviso, no cada semana
// como "weekly". La torre no usa nada experimental.
const SDK_VERSION = "quarterly";
/**
 * El SDK se configura una sola vez por documento (setOptions ignora las
 * llamadas siguientes). Si un build distinto pidiera otra clave en la misma
 * pagina es un error de configuracion, no algo a tolerar.
 */
let configuredKey = null;
const authListeners = new Set();
export const googleMapsLoader = {
    async load(apiKey) {
        if (configuredKey === null) {
            window.gm_authFailure = () => {
                for (const listener of authListeners)
                    listener();
            };
            // Idioma y region de la operacion: nombres de calles y controles en
            // castellano, sesgo de resultados a Argentina.
            setOptions({ key: apiKey, v: SDK_VERSION, language: "es", region: "AR" });
            configuredKey = apiKey;
        }
        else if (configuredKey !== apiKey) {
            throw new Error("El SDK de Google Maps ya se cargo con otra clave");
        }
        const [maps, marker] = await Promise.all([importLibrary("maps"), importLibrary("marker")]);
        return {
            Map: maps.Map,
            Polyline: maps.Polyline,
            AdvancedMarkerElement: marker.AdvancedMarkerElement,
        };
    },
    onAuthFailure(listener) {
        authListeners.add(listener);
        return () => {
            authListeners.delete(listener);
        };
    },
};
//# sourceMappingURL=googleMapsLoader.js.map